import React from "react";
import "./App.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { CareerForm } from "./components/CareerForm";
import { Box, Button, Container, Grid, Link, Stack } from "@mui/material";
import bannerImg from "./images/banner.webp";
import grey from "@mui/material/colors/grey";

import { Philosophy } from "./components/Philosophy";
import { Benefit } from "./components/Benefit";
import { StaffComments } from "./components/StaffComments";

function ButtonLink(props: { label: string; href: string }) {
  return (
    <>
      <Link href={props.href} color={grey[800]}>
        <Button
          variant={"contained"}
          color={"inherit"}
          disableElevation
          sx={{
            "&:hover": { background: grey[400] },
            textTransform: "initial",
          }}
          size={"medium"}
        >
          {props.label}
        </Button>
      </Link>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Container maxWidth={"md"} sx={{ width: "100%", m: "auto" }}>
        <CareerForm />
      </Container>
    </div>
  );
}

export default App;
